import React, { createContext, useState, useEffect } from "react";
import { getHighCostPatients } from "../services/getHighCostPatients";
import { useValidToken } from "../../../hooks/useValidToken";

export const HighCostContext = createContext();

export const HighCostProvider = ({ children }) => {
  const [highCostPatients, setHighCostPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [locationId, setLocationId] = useState(null);
  const [memberType, setMemberType] = useState(null);

  const { token, isValid, authLoading } = useValidToken();

  useEffect(() => {
    const fetchData = async () => {
      if (authLoading || !isValid) return;

      setLoading(true);
      setError(null);

      try {
        const data = await getHighCostPatients(null, locationId, memberType);
        setHighCostPatients(data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [authLoading, isValid, locationId, memberType]);

  return (
    <HighCostContext.Provider value={{
      highCostPatients,
      loading,
      error,
      setLocationId,
      setMemberType,
    }}>
      {children}
    </HighCostContext.Provider>
  );
};
